import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { CfmAddonDetailComponent } from '../cfm-addon-detail/cfm-addon-detail.component';
import { BogoOfferPopupComponent } from '../bogo-offer-popup/bogo-offer-popup.component';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { AccountService } from 'src/app/services/account.service';
import { SubjectService } from 'src/app/services/subject.service';
import { VerificationComponent } from '../verification/verification.component';

@Component({
  selector: 'postpaid-line-plan-passes-component',
  templateUrl: './postpaid-line-plan-passes-component.component.html',
  styleUrls: ['./postpaid-line-plan-passes-component.component.scss'],
})
export class PostpaidLinePlanPassesComponentComponent implements OnInit {
  @Input('sku') sku: any;
	@Input('addonType') addonType: any;
	@Input('source') source: String;
	@Output() onSelectPass: EventEmitter<any> = new EventEmitter();
	isArabic: boolean = false;

	constructor(private UTS: UtilitiesService,
		private modalController: ModalController,
		private SKUDS: SkuDataService,
		private AS: AccountService,
		private SS: SubjectService
	) { }

	ngOnInit(): void {
		this.isArabic = this.UTS.getLocaleLanguage().toLocaleLowerCase() === 'ar';
	}

	openAddonDetailsCfmView(): void{
		let data =  {
			cmsUrl: !this.isArabic ? this.sku.learnMore: this.sku.learnMoreAr,
			sku: this.sku
		}
		this.openBottomSheet(CfmAddonDetailComponent,
			{ data },
			'eand-full-height-screen eand-full-screen' 
			);
	}

	async openBottomSheet(component, data:any, cssClass:any ='verification-modal modal-fullscreen ') {
		const modal = await this.modalController.create({
		component: component,
		showBackdrop: true,
		backdropDismiss: true,
		componentProps: { data: data },
		cssClass: cssClass,
		});
		return await modal.present();
	}

	showBogoPopup(){
		this.openBottomSheet(BogoOfferPopupComponent, null, 'verification-modal eand-partail-height-screen-bottom-70-mobile');
	}
	subscribeAddon(){
		this.SKUDS.set(this.sku);
		//   this.SDS.setAddon(this.addon);
		this.SS.resetVerification.next(true)
		setTimeout(() => {
			let catID = '';
			if(localStorage.getItem('CAT')){
			catID = localStorage.getItem('CAT');
			}
			this.buyAddon(this.sku);
		}, 500);
  	}
	buyAddon(sku: any){
		const userInfo: any = this.AS.getUInfo();
		this.SS.skuDetails.next(sku);
		this.openBottomSheet(VerificationComponent,{type:this.addonType});
	}
	onClickPass(){
		this.onSelectPass.emit({sku: this.sku});
	}

}
